import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Typography, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-hot-toast';
import { getEndpoint } from '../config';

const API_URL = getEndpoint('FAQ');

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchFaqs = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        toast.error('توکن احراز هویت یافت نشد. لطفاً دوباره وارد شوید.');
        window.location.href = '/login';
        return;
      }
      
      const res = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFaqs(res.data);
    } catch (err) {
      console.error('Error fetching FAQs:', err);
      if (err.response && err.response.status === 401) {
        toast.error('توکن منقضی شده است. لطفاً دوباره وارد شوید.');
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else if (err.response && err.response.status === 403) {
        toast.error('توکن نامعتبر است. لطفاً دوباره وارد شوید.');
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        toast.error('خطا در دریافت سوالات');
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleOpen = (faq = null) => {
    if (faq) {
      setEditId(faq.id);
      setQuestion(faq.question);
      setAnswer(faq.answer);
    } else {
      setEditId(null);
      setQuestion('');
      setAnswer('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setQuestion('');
    setAnswer('');
  };

  const handleSubmit = async () => {
    if (!question.trim() || !answer.trim()) {
      toast.error('سوال و پاسخ را وارد کنید');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      if (editId) {
        await axios.put(`${API_URL}/${editId}`, { question, answer }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('سوال ویرایش شد');
      } else {
        await axios.post(API_URL, { question, answer }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success('سوال اضافه شد');
      }
      fetchFaqs();
      handleClose();
    } catch (err) {
      toast.error('خطا در ذخیره سوال');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('آیا مطمئن هستید که می‌خواهید این سوال را حذف کنید؟')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('سوال حذف شد');
      fetchFaqs();
    } catch (err) {
      toast.error('خطا در حذف سوال');
    }
  };

  return (
    <Box sx={{ fontFamily: 'Vazir', direction: 'rtl' }}>
      <Typography variant="h5" sx={{ mb: 2, fontFamily: 'Vazir', fontWeight: 'bold' }}>سوالات متداول</Typography>
      <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ mb: 2, fontFamily: 'Vazir' }}>
        افزودن سوال
      </Button>
      <TableContainer component={Paper} sx={{ fontFamily: 'Vazir' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="right" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>سوال</TableCell>
              <TableCell align="right" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>پاسخ</TableCell>
              <TableCell align="center" sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>عملیات</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {faqs.map((faq) => (
              <TableRow key={faq.id}>
                <TableCell align="right" sx={{ fontFamily: 'Vazir' }}>{faq.question}</TableCell>
                <TableCell align="right" sx={{ fontFamily: 'Vazir' }}>{faq.answer}</TableCell>
                <TableCell align="center">
                  <IconButton color="primary" onClick={() => handleOpen(faq)}><EditIcon /></IconButton>
                  <IconButton color="error" onClick={() => handleDelete(faq.id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose} dir="rtl">
        <DialogTitle sx={{ fontFamily: 'Vazir' }}>{editId ? 'ویرایش سوال' : 'افزودن سوال'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="سوال"
            type="text"
            fullWidth
            value={question}
            onChange={e => setQuestion(e.target.value)}
            sx={{ fontFamily: 'Vazir' }}
          />
          <TextField
            margin="dense"
            label="پاسخ"
            type="text"
            fullWidth
            multiline
            minRows={3}
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            sx={{ fontFamily: 'Vazir' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ fontFamily: 'Vazir' }}>انصراف</Button>
          <Button onClick={handleSubmit} variant="contained" sx={{ fontFamily: 'Vazir' }}>{editId ? 'ذخیره' : 'افزودن'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FAQ; 